import { IconWrapper } from '../runtime';
export default IconWrapper('windmill-one', true, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 48 48",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M34.5175 13.8463L34 11L27.1305 7.56525C25.1598 6.5799 22.8402 6.5799 20.8695 7.56525L17.3813 9.30938M35.6917 20.3046L37 27.5L39.0909 39M36 44H8L8.956 38.742M10.6364 29.5L13.5718 13.3554",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M39.2929 8.70711C39.6834 8.31658 40.3166 8.31658 40.7071 8.70711L43.2929 11.2929C43.6834 11.6834 43.6834 12.3166 43.2929 12.7071L34.7071 21.2929C34.3166 21.6834 33.6834 21.6834 33.2929 21.2929L30.7071 18.7071C30.3166 18.3166 30.3166 17.6834 30.7071 17.2929L39.2929 8.70711Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M27 21L31 17",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M39.2929 39.2929C39.6834 39.6834 39.6834 40.3166 39.2929 40.7071L36.7071 43.2929C36.3166 43.6834 35.6834 43.6834 35.2929 43.2929L26.7071 34.7071C26.3166 34.3166 26.3166 33.6834 26.7071 33.2929L29.2929 30.7071C29.6834 30.3166 30.3166 30.3166 30.7071 30.7071L39.2929 39.2929Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M27 27L31 31",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M8.70711 39.2929C8.31658 39.6834 7.68342 39.6834 7.29289 39.2929L4.70711 36.7071C4.31658 36.3166 4.31658 35.6834 4.70711 35.2929L13.2929 26.7071C13.6834 26.3166 14.3166 26.3166 14.7071 26.7071L17.2929 29.2929C17.6834 29.6834 17.6834 30.3166 17.2929 30.7071L8.70711 39.2929Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M21 27L17 31",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M8.70711 8.70711C8.31658 8.31658 8.31658 7.68342 8.70711 7.29289L11.2929 4.70711C11.6834 4.31658 12.3166 4.31658 12.7071 4.70711L21.2929 13.2929C21.6834 13.6834 21.6834 14.3166 21.2929 14.7071L18.7071 17.2929C18.3166 17.6834 17.6834 17.6834 17.2929 17.2929L8.70711 8.70711Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M21 21L17 17",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("circle", {
    "attrs": {
      "cx": "24",
      "cy": "24",
      "r": "4",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth
    }
  })]);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@icon-park/vue/es/icons/WindmillOne.js
// module id = null
// module chunks = 